import { useGetIdentity } from "ra-core";

import type { ActiveFilterBarProps } from "../misc/ActiveFilterBar";
import { optionsDescriptor, searchDescriptor } from "../misc/activeFilters";
import { useConfigurationContext } from "../root/ConfigurationContext";

/** The company list's active-filter chips, in sidebar order. */
export const useCompanyFilterBar = (): ActiveFilterBarProps => {
  const { identity } = useGetIdentity();
  const { recordTypes } = useConfigurationContext();

  return {
    descriptors: [
      searchDescriptor(),
      optionsDescriptor(
        ["record_type"],
        recordTypes.map((type) => ({
          label: type.label,
          value: { record_type: type.value },
        })),
      ),
      optionsDescriptor(
        ["sales_id"],
        [{ label: "crm.common.me", value: { sales_id: identity?.id } }],
      ),
    ],
  };
};
